import { useTranslation } from 'react-i18next';

import { Button, CheckmarkIcon, Modal, Paragraph, Popover } from '@treams/treams-ui';

// Confirms saving a superuser correction of a submitted talent review.
export default function SaveTalentReviewCorrectionModal(props: {
	/** Formatted grid day of the snapshot being corrected. */
	date: string;
	loading?: boolean;
	onClose: () => void;
	onConfirm: () => void;
}) {
	const { t } = useTranslation();

	return (
		<Popover visible center onDismiss={props.onClose}>
			<Modal>
				<Modal.Header
					title={t('talentReviews.v2.snapshot.correcting.saveTitle')}
					onClose={props.onClose}
				/>
				<Modal.Contents>
					<Paragraph>
						{t('talentReviews.v2.snapshot.correcting.saveConfirm', { date: props.date })}
					</Paragraph>
				</Modal.Contents>
				<Modal.Footer>
					<Button
						type="secondary"
						title={t('talentReviews.v2.cancel')}
						disabled={props.loading}
						onClick={props.onClose}
					/>
					<Button
						ml={2}
						type="primary"
						icon={<CheckmarkIcon />}
						title={t('talentReviews.v2.snapshot.correcting.save')}
						loading={props.loading}
						onClick={props.onConfirm}
					/>
				</Modal.Footer>
			</Modal>
		</Popover>
	);
}
